import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { createSelector } from 'reselect';
import { LayoutType } from '../../../types/layouts.esm.js';
import { applyLayout } from '../../../utilities/apply-layout.esm.js';
import { getCommands } from '../../../utilities/get-commands.esm.js';
import { getCustomLayout } from '../../../utilities/get-custom-layout.esm.js';
import { getSelectedLayout } from '../../../utilities/get-selected-layout.esm.js';

function changeDefaultLayout(_x, _x2, _x3, _x4, _x5, _x6) {
  return _changeDefaultLayout.apply(this, arguments);
}
function _changeDefaultLayout() {
  _changeDefaultLayout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(layouts, onChange, displayLayouts, setDisplayLayouts, onSaveLayout, onDeleteLayout) {
    var newLayout, newLayouts;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          newLayout = getSelectedLayout(displayLayouts);
          newLayouts = applyLayout(layouts, newLayout);
          _context2.t0 = newLayout.type;
          _context2.next = _context2.t0 === LayoutType.Default ? 5 : 9;
          break;
        case 5:
          if (displayLayouts !== newLayouts) {
            setDisplayLayouts(newLayouts);
          }
          _context2.next = 8;
          return getCommands({
            onSaveLayout: onSaveLayout,
            onDeleteLayout: onDeleteLayout
          })(layouts, newLayouts);
        case 8:
          return _context2.abrupt("break", 14);
        case 9:
          if (layouts !== newLayouts) {
            onChange(newLayouts);
          }
          if (displayLayouts !== newLayouts) {
            setDisplayLayouts(newLayouts);
          }
          _context2.next = 13;
          return getCommands({
            onSaveLayout: onSaveLayout,
            onDeleteLayout: onDeleteLayout
          })(layouts, newLayouts);
        case 13:
          return _context2.abrupt("break", 14);
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _changeDefaultLayout.apply(this, arguments);
}
function changeCustomLayout(layouts, onChange, displayLayouts, setDisplayLayouts, onSaveLayout, onDeleteLayout) {
  var displayLayout = getSelectedLayout(displayLayouts);
  switch (displayLayout.type) {
    case LayoutType.Default:
      {
        var newSelectedLayout = getSelectedLayout(displayLayouts);
        var newLayouts = applyLayout(layouts, newSelectedLayout);
        if (newLayouts !== layouts) {
          onChange(newLayouts);
        }
        if (newLayouts !== displayLayouts) {
          setDisplayLayouts(newLayouts);
        }
        return getCommands({
          onSaveLayout: onSaveLayout,
          onDeleteLayout: onDeleteLayout
        })(layouts, newLayouts);
      }
    case LayoutType.Custom:
      {
        var newCustomLayout = getCustomLayout(displayLayouts);
        if (!newCustomLayout) {
          throw new Error('A custom layout should be selected');
        }
        var _newLayouts = applyLayout(layouts, newCustomLayout);
        if (_newLayouts !== layouts) {
          onChange(_newLayouts);
        }
        if (_newLayouts !== displayLayouts) {
          setDisplayLayouts(_newLayouts);
        }
        return getCommands({
          onSaveLayout: onSaveLayout,
          onDeleteLayout: onDeleteLayout
        })(layouts, _newLayouts);
      }
    case LayoutType.Predefined:
    case LayoutType.Saved:
      {
        var _newSelectedLayout = getSelectedLayout(displayLayouts);
        var _newLayouts2 = applyLayout(layouts, _newSelectedLayout);
        if (_newLayouts2 !== layouts) {
          onChange(_newLayouts2);
        }
        if (_newLayouts2 !== displayLayouts) {
          setDisplayLayouts(_newLayouts2);
        }
        return getCommands({
          onSaveLayout: onSaveLayout,
          onDeleteLayout: onDeleteLayout
        })(layouts, _newLayouts2);
      }
    default:
      throw new Error('Unknown type.');
  }
}
function changeSavedLayout(layouts, onChange, displayLayouts, setDisplayLayouts, onSaveLayout, onDeleteLayout) {
  var displayLayout = getSelectedLayout(displayLayouts);
  var newLayouts = applyLayout(layouts, displayLayout);
  if (newLayouts !== layouts) {
    onChange(newLayouts);
  }
  if (newLayouts !== displayLayouts) {
    setDisplayLayouts(newLayouts);
  }
  return getCommands({
    onSaveLayout: onSaveLayout,
    onDeleteLayout: onDeleteLayout
  })(layouts, newLayouts);
}
function changePredefinedLayout(_x7, _x8, _x9, _x10, _x11, _x12) {
  return _changePredefinedLayout.apply(this, arguments);
}
function _changePredefinedLayout() {
  _changePredefinedLayout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(layouts, onChange, displayLayouts, setDisplayLayouts, onSaveLayout, onDeleteLayout) {
    var displayLayout, oldLayout, newLayouts;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          displayLayout = getSelectedLayout(displayLayouts);
          oldLayout = getSelectedLayout(layouts);
          if (!(displayLayout.id === oldLayout.id)) {
            _context3.next = 4;
            break;
          }
          return _context3.abrupt("return");
        case 4:
          newLayouts = applyLayout(layouts, displayLayout);
          onChange(newLayouts);
          setDisplayLayouts(newLayouts);
          _context3.next = 9;
          return getCommands({
            onSaveLayout: onSaveLayout,
            onDeleteLayout: onDeleteLayout
          })(layouts, newLayouts);
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _changePredefinedLayout.apply(this, arguments);
}
function getApplyCallback(layouts, onChange, displayLayouts, setDisplayLayouts, onSaveLayout, onDeleteLayout) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var liveLayout;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          liveLayout = getSelectedLayout(layouts);
          _context.t0 = liveLayout.type;
          _context.next = _context.t0 === LayoutType.Default ? 4 : _context.t0 === LayoutType.Custom ? 7 : _context.t0 === LayoutType.Saved ? 10 : _context.t0 === LayoutType.Predefined ? 13 : 16;
          break;
        case 4:
          _context.next = 6;
          return changeDefaultLayout(layouts, onChange, displayLayouts, setDisplayLayouts, onSaveLayout, onDeleteLayout);
        case 6:
          return _context.abrupt("return");
        case 7:
          _context.next = 9;
          return changeCustomLayout(layouts, onChange, displayLayouts, setDisplayLayouts, onSaveLayout, onDeleteLayout);
        case 9:
          return _context.abrupt("return");
        case 10:
          _context.next = 12;
          return changeSavedLayout(layouts, onChange, displayLayouts, setDisplayLayouts, onSaveLayout, onDeleteLayout);
        case 12:
          return _context.abrupt("return");
        case 13:
          _context.next = 15;
          return changePredefinedLayout(layouts, onChange, displayLayouts, setDisplayLayouts, onSaveLayout, onDeleteLayout);
        case 15:
          return _context.abrupt("return");
        case 16:
          throw new Error('Unknown type.');
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}
var createApplyCallbackSelector = function createApplyCallbackSelector() {
  return createSelector(function (props) {
    return props.layouts;
  }, function (props) {
    return props.onChange;
  }, function (props) {
    return props.displayLayouts;
  }, function (props) {
    return props.setDisplayLayouts;
  }, function (props) {
    return props.onSaveLayout;
  }, function (props) {
    return props.onDeleteLayout;
  }, getApplyCallback);
};

export { createApplyCallbackSelector, getApplyCallback };
//# sourceMappingURL=apply-callback-selector.esm.js.map
